module.exports = __webpack_public_path__ + "static/gray1-d3ad07d4fbdb52e99c1a39eb924762bd.png";